import moment from 'moment'

// Access card issue log, same idea as Windows MyClass.WriteToFile(): the Windows app
// appends "date|folio|room|checkin|checkout|user" to %USERPROFILE%\RatriLogs\AccessCard_M_YYYY.txt
// on the front desk PC. The web app cannot write files, so it keeps the same lines in
// this browser's localStorage, one list per property.

const MAX_LINES = 5000;

function storageKey()
{
    try
    {
        let obj = JSON.parse(localStorage.getItem('currentproperty'));
        if (obj !== null && obj !== undefined && obj.id !== undefined)
        {
            return `accesscardlog_${obj.id}`;
        }
    }
    catch (e)
    {
    }

    return 'accesscardlog';
}

export function readCardLog()
{
    try
    {
        let list = JSON.parse(localStorage.getItem(storageKey()));
        return Array.isArray(list) ? list : [];
    }
    catch (e)
    {
        return [];
    }
}

export function addCardLog(folioNo, roomNo, start, end)
{
    try
    {
        let list = readCardLog();

        list.push({
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            no: folioNo !== undefined && folioNo !== null ? folioNo : '',
            roomno: roomNo !== undefined && roomNo !== null ? roomNo : '',
            start: moment(start).format('YYYY-MM-DD HH:mm:ss'),
            end: moment(end).format('YYYY-MM-DD HH:mm:ss'),
            by: localStorage.getItem('name') || ''
        });

        if (list.length > MAX_LINES)
        {
            list = list.slice(list.length - MAX_LINES);
        }

        localStorage.setItem(storageKey(), JSON.stringify(list));
    }
    catch (e)
    {
        // Logging must never stop a card from being issued.
    }
}

// Parses a Windows AccessCard_M_YYYY.txt file (one "date|folio|room|checkin|checkout|user" per line).
export function parseWindowsCardLog(text)
{
    let rows = [];

    for (let line of (text || '').split(/\r?\n/))
    {
        if (line.trim() === '')
        {
            continue;
        }

        let d = line.split('|');
        if (d.length < 6)
        {
            continue;
        }

        // Windows writes DateTime.Now in the PC's own format; Malaysian PCs use day/month first.
        let dt = moment(d[0].trim(), ['D/M/YYYY h:mm:ss A', 'D/M/YYYY H:mm:ss', 'D-M-YYYY h:mm:ss A', 'D-M-YYYY H:mm:ss', 'YYYY-MM-DD HH:mm:ss'], true);

        rows.push({
            date: dt.isValid() ? dt.format('YYYY-MM-DD HH:mm:ss') : d[0],
            no: d[1],
            roomno: d[2],
            start: d[3],
            end: d[4],
            by: d[5],
            source: 'Windows'
        });
    }

    return rows;
}
